import {NgModule} from '@angular/core';
import {FormlyQuantityModule} from './fields/quantity/formly-quantity.module';
import {FormlyDatePickerModule} from './fields/duration/date-picker/formly-date-picker.module';
import {FormlyRenewalModule} from './fields/duration/renewal/renewal.module';
import {FormlyContractDurationModule} from './fields/duration/contract-duration/contract-duration.module';
import {FormlyDurationLabelModule} from './fields/duration/duration-label/duration-label.module';
import {EuAccessModule} from './fields/eu-access/eu-access.module';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyDurationLabelComponent} from './fields/duration/duration-label/duration-label.component';

@NgModule({
  imports: [
    FormlyQuantityModule,
    FormlyDatePickerModule,
    FormlyDurationLabelModule,
    FormlyContractDurationModule,
    FormlyRenewalModule,
    EuAccessModule,
    FormlyModule.forRoot({
      wrappers: [
        {name: 'duration-label', component: FormlyDurationLabelComponent},
      ],
    }),
  ],
})
export class FormlyDcpModule {
}
